export interface UserPermissions {
  id: number;
  username: string;
  permission: string;
  addDate: Date;
}
